export default "https://cdn-static.gokick.com/assets/96917af4b324ebd1ae50a0309f8a33967fe87b4d/images/sleep-green-apple.f225c952c3b7c02c96ff4f722551ea5d.png";